import React from "react";
import classes from "./Spinner.module.css";
import Logo from "../../../assets/Img/pcariMainToolBarLogo.png";
import { Container } from "react-bootstrap";

const Spinner = (props) => {
  // return (
  //     <div className={classes.Spineer}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  // );
  return (
    <Container>
      <div
        style={{ height: "100vh" }}
        className="d-flex flex-column justify-content-center align-items-center "
      >
        <img
          className="img-fliud"
          src={Logo}
          alt="loading"
          style={{ width: "100%" }}
        />
        <div className={classes.Spineer}>
          <div></div>
          <div></div>
        </div>
      </div>
    </Container>
  );
};

export default Spinner;
